import { render, staticRenderFns } from "./ProductionDoctorChart.vue?vue&type=template&id=bec212ec&scoped=true&"
import script from "./ProductionDoctorChart.vue?vue&type=script&lang=js&"
export * from "./ProductionDoctorChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec212ec",
  null
  
)

export default component.exports